import React from "react";
import { GALLERY } from "../mock";
import Footer from "../components/Footer";

export default function Gallery() {
  return (
    <div className="bg-white min-h-screen">
      <section className="hero-dark pt-28 pb-14">
        <div className="max-w-7xl mx-auto px-5">
          <p className="text-xs font-semibold tracking-widest text-amber-400 uppercase">Visual Stories</p>
          <h1 className="mt-2 text-4xl md:text-5xl font-bold text-white">Tour Highlights &amp; Gallery</h1>
          <p className="mt-3 text-slate-300 max-w-xl">Real moments from our group departures across the world.</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-5 py-12">
        <div className="columns-2 md:columns-3 lg:columns-4 gap-4 space-y-4">
          {GALLERY.map((g, i) => (
            <div key={i} className="break-inside-avoid group relative rounded-xl overflow-hidden">
              <img src={g.image} alt={g.tag} className="w-full object-cover transition-transform duration-700 group-hover:scale-105"
                style={{ height: `${180 + (i % 3) * 60}px` }} />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
              <span className="absolute bottom-3 left-3 text-sm font-semibold text-white opacity-0 group-hover:opacity-100 transition-opacity">{g.tag}</span>
            </div>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
